export function getUserGroup(openIdClaims){
  if (!openIdClaims || !Array.isArray(openIdClaims.groups)) {
    return undefined;
  }

  return openIdClaims.groups.map(value => {
     const grpInfoArr = value.split('.');
      let returnvalue ='';
       if(grpInfoArr[grpInfoArr.length-1]==='lab-external' || grpInfoArr[grpInfoArr.length-1]==='Labs'){
          returnvalue='Labs'
       }
       else if(grpInfoArr[grpInfoArr.length-1]==='factory-external' || grpInfoArr[grpInfoArr.length-1]==='Factories' ) {
        returnvalue = 'Factories'
       }
       else if(grpInfoArr[grpInfoArr.length-1]==='supplier-external' || grpInfoArr[grpInfoArr.length-1]==='Suppliers'){
        returnvalue = 'Suppliers'
       }
       else if(grpInfoArr[grpInfoArr.length-1]==='whq-internal' || grpInfoArr[grpInfoArr.length-1]==='Rsl'){
        returnvalue = 'Rsl'
      }
      else if(grpInfoArr[grpInfoArr.length-1]==='whq-internal' || grpInfoArr[grpInfoArr.length-1] === 'rsl-profile'){
        returnvalue = 'Profile'
      }
      else if(grpInfoArr[grpInfoArr.length-1]==='pmo'){
        returnvalue = 'Nlo'
      }
      return returnvalue
    })[0]
  }


const tokenBase = {
    get isExpired() {
      return ((this.expiresAt-300) * 1000) < Date.now();
    }
  };

const makeToken = token => Object.assign(Object.create(tokenBase), token);

function unpackEncodedToken(authStates) {
    if (!authStates || !authStates.accessToken || !authStates.idToken) return null;

  const accessValues = authStates.accessToken;
  const openIdValues = authStates.idToken;
  const accessClaims = accessValues && accessValues.claims;
  const openIdClaims = openIdValues && openIdValues.claims;
  if (!openIdClaims) return null;

  // Some Okta token objects may not include access token claims on initial load.
  // Fall back to token-level expiresAt so auth bootstrap can continue.
  const expiresAt = (accessClaims && accessClaims.exp) || accessValues.expiresAt;
  if (!expiresAt) return null;

  const fullName = openIdClaims.name || `${openIdClaims.given_name || ''} ${openIdClaims.family_name || ''}`.trim();
  const nameSplit = fullName ? fullName.split(" ") : [];
    // The name of these values will depend on the token issuer
    // Ping and Okta have different values for scope and username
    return {
    isAuthenticated: authStates.isAuthenticated,
    accessToken: authStates.accessToken.accessToken,
    openIdToken: authStates.idToken,
    expiresAt,
    username: (accessClaims && accessClaims.sub) || openIdClaims.sub || '',
    email: openIdClaims.email || (accessClaims && accessClaims.sub) || '',
    firstName: nameSplit[0] || '',
    lastName: nameSplit.slice(1).join(' ') || '',
    fullName: fullName || '',
    scope: (accessClaims && accessClaims.scp) || '',
    group: getUserGroup(openIdClaims)
    };    
  }

  export function getFullToken(authStates){

    let tokenInfo = unpackEncodedToken(authStates)
    if (!tokenInfo) {
      return null
    }
    tokenInfo= makeToken(tokenInfo)
    return tokenInfo
  }
